module.exports = __webpack_public_path__ + "img/artheart.4df2a4e7.png";